import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Button, Stack, Stepper, Step, StepLabel, Checkbox, FormControlLabel, StepConnector, stepConnectorClasses, TextField, useMediaQuery, Box, FormControl, MenuItem, useTheme, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { addPurchase, deletePurchaseDetails, editPurchase, getAllPurchaseProduct, getAllPurchaseVendor, getAllPurchaseWarehouse, getAllTermsAndCondition, getPurchase, viewPurchase } from '../../../redux/slice/Purchase.slice';
import { getProducts } from '../../../redux/slice/products.slice';
import AddIcon from '@mui/icons-material/Add';
import { getVendors } from '../../../redux/slice/vendors.slice';
import { getWarehouses } from '../../../redux/slice/warehouses.slice';
import { getRoles } from '../../../redux/slice/roles.slice';
import { getTerms } from '../../../redux/slice/Terms.slice';
import DeleteIcon from '@mui/icons-material/Delete';


const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'none',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#134670 0%, #2B89D5 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
    // Styles for all screen sizes
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        left: 'calc(-50% + 20px)',
        right: 'calc(50% + 20px)',
    },
    // Adjustments for very small screens
    '@media (max-width: 425px)': {
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 15,
            left: 'calc(-50% + 15px)',
            right: 'calc(50% + 15px)',
        },
    },
    // Adjustments for medium to large screens
    '@media (min-width: 426px)': {
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 25,
            left: 'calc(-50% + 25px)',
            right: 'calc(50% + 25px)',
        },
    },

}));


const ColorlibStepIconRoot = styled('div')(({ theme, ownerState, isVerySmallScreen }) => ({
    // backgroundColor: ownerState.completed ? '#ff6b39' : '#ccc',
    backgroundColor: ownerState.completed ? '#134670' : ownerState.filled ? '#134670' : '#ccc',
    zIndex: 1,
    // color: ownerState.completed ? '#fff' : '#000',
    color: (ownerState.completed || ownerState.filled) ? '#fff' : '#000',
    width: isVerySmallScreen ? 30 : 50,
    height: isVerySmallScreen ? 30 : 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: ownerState.active ? '2px solid #008cff' : '',
    ...(ownerState.active && {
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
}));

function ColorlibStepIcon(props) {
    const { active, completed, filled, className, icon } = props;
    const isVerySmallScreen = useMediaQuery('(max-width:425px)');

    return (
        <ColorlibStepIconRoot
            ownerState={{ completed, filled, active }}
            className={className}
            isVerySmallScreen={isVerySmallScreen}
        >
            <Typography variant={isVerySmallScreen ? "body2" : "h6"} style={{ fontWeight: 'bold', color: completed ? '#fff' : '#000' }}>
                {icon}
            </Typography>
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    filledSteps: PropTypes.array,
};

const steps = ['Purchase Order(PO) Generate', 'Partially Payment', 'Payment to Vendor', 'Partially Material', 'Material Recieved at Store'];

const validationSchemas =
    Yup.object({});

const initialValues = {
    // SrNo: '',
    multipledata: [{
        productName: '',
        description: '',
        HSHCode: '',
        // total: '',
        unitPrice: '',
        gst: '',
        // gstAmount: '',
        Qty: '',
    }],
    vendor: '',
    werehouse: '',
    taxableAmount: '',
    totalGstAmount: '',
    amountTotal: 0,
};

const MobileStepper = ({ steps, activeStep, completedSteps, filledSteps }) => {
    const isVerySmallScreen = useMediaQuery('(max-width:425px)');
    const isMediumScreen = useMediaQuery('(min-width:426px) and (max-width:1024px)');
    const theme = useTheme();



    const renderStep = (label, index) => (
        <Step key={label} completed={completedSteps.includes(index)}>
            <StepLabel
                StepIconComponent={ColorlibStepIcon}
                icon={index + 1}
                StepIconProps={{
                    // filled: filledSteps.includes(index)
                    active: index === activeStep,
                    completed: completedSteps.includes(index),
                    filled: filledSteps.includes(index)
                }}
            >

                <Typography style={{
                    color: completedSteps.includes(index) ? '#6da2cd' :
                        index === activeStep ? theme.palette.mode === 'dark' ? '#fff' : "#000" :
                            filledSteps.includes(index) ? '#6da2cd' : " ",
                    fontWeight: '600',
                    fontSize: isVerySmallScreen ? '10px' : '12px'
                }}>
                    {label}
                </Typography>
            </StepLabel>
        </Step>
    );

    if (isVerySmallScreen) {
        const groupedSteps = [];
        for (let i = 0; i < steps.length; i += 3) {
            groupedSteps.push(steps.slice(i, i + 3));
        }

        return (
            <Box>
                {groupedSteps.map((group, groupIndex) => (
                    <React.Fragment key={groupIndex}>
                        <Stepper
                            alternativeLabel
                            activeStep={activeStep - groupIndex * 3}
                            connector={<ColorlibConnector />}
                            sx={{
                                '& .MuiStepLabel-root': { padding: '0 4px' },
                                '& .MuiStepConnector-line': { top: 15 },
                                '& .MuiStepConnector-root': {
                                    left: 'calc(-50% + 15px)',
                                    right: 'calc(50% + 15px)',
                                },
                                '& .MuiStep-root:first-of-type .MuiStepConnector-root': {
                                    left: '50%',
                                },
                                '& .MuiStep-root:last-child .MuiStepConnector-root': {
                                    right: '50%',
                                },
                            }}
                        >
                            {group.map((label, index) => renderStep(label, groupIndex * 3 + index))}
                        </Stepper>
                        {groupIndex < groupedSteps.length - 1 && <Box sx={{ my: 2 }} />}
                    </React.Fragment>
                ))}
            </Box>
        );
    } else if (isMediumScreen) {
        const firstRowSteps = steps.slice(0, 5);
        const secondRowSteps = steps.slice(5);

        return (
            <Box>
                <Stepper alternativeLabel activeStep={activeStep > 4 ? 4 : activeStep} connector={<ColorlibConnector />}>
                    {firstRowSteps.map((label, index) => renderStep(label, index))}
                </Stepper>
                <Box sx={{ my: 1 }} />
                <Stepper alternativeLabel activeStep={activeStep > 5 ? activeStep - 5 : 0} connector={<ColorlibConnector />}>
                    {secondRowSteps.map((label, index) => renderStep(label, index + 5))}
                </Stepper>
            </Box>
        );
    } else {
        return (
            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                {steps.map((label, index) => renderStep(label, index))}
            </Stepper>
        );
    }
};

export default function Purchase() {
    const [activeStep, setActiveStep] = React.useState(0);
    const [stepsWithErrors, setStepsWithErrors] = React.useState([]);
    const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);
    const [SrNo, setSrNo] = useState('');
    const [purchasemap, setpurchasemap] = useState(initialValues.multipledata)
    const isVerySmallScreen = useMediaQuery('(max-width:425px)');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:500px)');
    const purchase = useSelector(state => state.purchase.purchase);
    const vendor = useSelector(state => state.purchase.vendor);
    const Warehouse = useSelector(state => state.purchase.warehouses);
    const product = useSelector(state => state.purchase.products);
    const termsAndCondition = useSelector(state => state.purchase.terms);
    const storeData = useSelector((state) => state.purchase.store);

    console.log("storeData", storeData);


    const { state } = useLocation();
    const purchaseData = state;
    const [completedSteps, setCompletedSteps] = useState(purchaseData?.filledSteps?.map((v) => parseInt(v)) || []);
    const [filledSteps, setFilledSteps] = useState(purchaseData?.filledSteps || []);
    const [acceptedTerms, setAcceptedTerms] = useState({});

    const handleTermChange = (termId) => {
        setAcceptedTerms(prev => ({
            ...prev,
            [termId]: !prev[termId]
        }));
    };

    useEffect(() => {
        if (purchaseData?._id && purchaseData?.acceptedTerms) {
            const initialAcceptedTerms = purchaseData.acceptedTerms.reduce((acc, termId) => {
                acc[termId] = true;
                return acc;
            }, {});
            setAcceptedTerms(initialAcceptedTerms);
        }
    }, [purchaseData]);

    const isLastStep = activeStep === steps.length - 1;
    const [isNewPurchase, setIsNewPurchase] = useState(true);

    const hasFetchedData = React.useRef(false);

    React.useEffect(() => {
        dispatch(getPurchase());
        // dispatch(getProducts());
        // dispatch(getVendors());
        // dispatch(getWarehouses());  
        // dispatch(getTerms());
        dispatch(getAllPurchaseVendor());
        dispatch(getAllPurchaseWarehouse());
        dispatch(getAllPurchaseProduct())
        dispatch(getAllTermsAndCondition())


        if (purchaseData?._id) {
            setValues(purchaseData);
            setFilledSteps(purchaseData?.filledSteps || []);
            setIsNewPurchase(false);
        } else {
            resetForm();
            setpurchasemap([{
                productName: '',
                description: '',
                HSHCode: '',
                // total: '',
                unitPrice: '',
                gst: '',
                // gstAmount: '',
                Qty: '',
            }]);
            setIsNewPurchase(true);
        }
    }, [dispatch, purchaseData?._id])


    React.useEffect(() => {
        if (isNewPurchase) {
            const currentDate = new Date();
            let financialYear;

            if (currentDate.getMonth() >= 3) {
                financialYear = `${currentDate.getFullYear()}-${(currentDate.getFullYear() + 1).toString().slice(-2)}`;
            } else {
                financialYear = `${currentDate.getFullYear() - 1}-${currentDate.getFullYear().toString().slice(-2)}`;
            }

            let sequenceNumber = 1;

            if (purchase && purchase.length > 0) {
                let lastFillNo = purchase[purchase.length - 1]?.SrNo;
                if (lastFillNo) {
                    const parts = lastFillNo.split('/');
                    sequenceNumber = parseInt(parts[2]) + 1;
                }
            }

            setSrNo(`TEL/${financialYear}/${sequenceNumber.toString().padStart(4, '0')}`);
        } else {
            if (Array.isArray(purchase)) {
                const updateFillNo = purchase.find(item => item._id === purchaseData._id);
                if (updateFillNo) {
                    setSrNo(updateFillNo.SrNo);
                }
            }
        }
    }, [purchase, isNewPurchase]);

    const [description, setDescription] = useState();
    const [HSHCode, setHSHCode] = useState();

    const isStepFilled = (step) => {
        const stepFields = {
            0: ['SrNo', 'vendor', 'werehouse', 'productName', 'description', 'HSHCode', 'Qty', 'unitPrice', 'gst', 'gstAmount', 'total', 'taxableAmount', 'totalGstAmount', 'amountTotal'],
            1: ['', ''],
            2: ['', ''],
            3: ['', ''],
            4: ['', ''],
        };

        if (!stepFields[step]) return false;
        return stepFields[step].every(field => values[field]);
    };


    const handleNext = (values, actions) => {
        setTouchedSteps((prevTouchedSteps) => {
            const newTouchedSteps = [...prevTouchedSteps];
            newTouchedSteps[activeStep] = true;
            return newTouchedSteps;
        });
        if (isStepFilled(activeStep)) {
            setFilledSteps(prev => [...new Set([...prev, activeStep.toString()])]);
            setCompletedSteps(prev => [...new Set([...prev, activeStep])]);
        } if (!isLastStep) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            actions.validateForm().then((errors) => {
                if (Object.keys(errors).length === 0) {
                    const submissionValues = {
                        ...values,
                        filledSteps,
                        multipledata: values.multipledata.map(item => ({
                            ...item,
                            total: item.Qty * item.unitPrice, // Ensure total is calculated
                            gstAmount: (item.gst * item.Qty * item.unitPrice) / 100 // Ensure gstAmount is calculated
                        })),
                        vendor: values.vendor,
                        werehouse: values.werehouse,
                        taxableAmount: values.taxableAmount,
                        totalGstAmount: totalGstAmount,
                        amountTotal: values.taxableAmount + totalGstAmount,
                        SrNo: SrNo,
                        acceptedTerms: Object.keys(acceptedTerms).filter(termId => acceptedTerms[termId]),
                    };

                    if (purchaseData?._id) {
                        delete submissionValues.isActive;
                        delete submissionValues.createdAt;
                        delete submissionValues.updatedAt;
                        dispatch(editPurchase({ id: values?._id, ...submissionValues, navigate })).then(() => {
                            dispatch(getPurchase())
                        });
                    } else {
                        dispatch(addPurchase({ data: { ...submissionValues, SrNo }, navigate })).then(() => {
                            dispatch(getPurchase())
                        });
                    }
                    actions.resetForm();
                    setValues(initialValues);
                    setpurchasemap(initialValues.multipledata);
                    navigate('/admin/purchase');
                    setActiveStep(0);
                    setAcceptedTerms({}); // Reset accepted terms
                } else {
                    console.log("Form validation errors:", errors);
                    setStepsWithErrors((prevStepsWithErrors) => {
                        const newStepsWithErrors = [...prevStepsWithErrors];
                        newStepsWithErrors[activeStep] = true;
                        return newStepsWithErrors;
                    });
                    alert('Please fix the errors in the form before submitting');
                }
                actions.setSubmitting(false);
            })
        }
    };

    React.useEffect(() => {
        if (purchaseData?._id) {
            dispatch(viewPurchase(purchaseData?._id)).then((response) => {
                if (response.payload) {
                    const perchaseData = response.payload;
                    const totalGstAmount = perchaseData.multipledata.reduce((sum, item) => {
                        const gstAmount = (parseFloat(item.gst) || 0) * ((parseFloat(item.Qty) || 0) * (parseFloat(item.unitPrice) || 0)) / 100;
                        return sum + gstAmount;
                    }, 0);
                    setValues({
                        ...perchaseData,
                        multipledata: [...perchaseData.multipledata],
                        totalGstAmount: totalGstAmount,
                        vendor: perchaseData.vendor,
                        werehouse: perchaseData.werehouse,
                    });
                    setpurchasemap([...perchaseData.multipledata]);
                    setTotalGstAmount(totalGstAmount);
                    setFieldValue('totalGstAmount', totalGstAmount);
                }
            }).catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }, [purchaseData?._id, dispatch]);


    const isNonMobile = useMediaQuery("(min-width:600px)");
    const theme = useTheme();


    const formik = useFormik({
        initialValues: { ...initialValues, multipledata: purchasemap },
        validationSchema: validationSchemas,
        onSubmit: handleNext,
    });
    const { handleBlur, handleChange, values, touched, errors, setFieldValue, setValues, validateForm, setFieldError, resetForm } = formik


    React.useEffect(() => {
        if (values?.productName) {
            let data = product?.find((v) => v._id == values.productName)
            setDescription(data?.Desacription)
            setHSHCode(data?.HSNcode)
        }
    }, [values])


    const handleSubmit = () => {


        setFilledSteps(prev => [...new Set([...prev, activeStep.toString()])]);
        validationSchemas.validate(values, { abortEarly: false })
            .then(() => {
                const submissionValues = {
                    ...values,
                    filledSteps: [...filledSteps, activeStep.toString()],
                    multipledata: values.multipledata.map(item => ({
                        ...item,
                        total: parseFloat(item.Qty) * parseFloat(item.unitPrice),
                        gstAmount: (parseFloat(item.gst) * parseFloat(item.Qty) * parseFloat(item.unitPrice)) / 100
                    })),
                    totalGstAmount: totalGstAmount,
                    amountTotal: parseFloat(values.taxableAmount) + parseFloat(totalGstAmount),
                    terms: Object.keys(acceptedTerms).filter(termId => acceptedTerms[termId]),
                };
                if (purchaseData?._id) {
                    dispatch(editPurchase({ id: purchaseData?._id, ...submissionValues })).then(() => {
                        dispatch(getPurchase())
                    });
                } else {
                    dispatch(addPurchase({
                        data: {
                            ...submissionValues,
                            SrNo,
                        },
                        navigate
                    }));
                }
                setActiveStep(0);
                navigate('/admin/purchase');
                resetForm();
                setIsNewPurchase(true);
                setpurchasemap([{
                    productName: '',
                    description: '',
                    HSHCode: '',
                    total: '',
                    unitPrice: '',
                    gst: '',
                    gstAmount: '',
                    Qty: '',
                }]);
                setAcceptedTerms({});

                setSrNo('');
                setTotalGstAmount(0);

            })
            .catch((validationErrors) => {
                console.log("Form validation errors:", validationErrors);
                alert("Please fill in all required fields before submitting.");
            });
        console.log("dtaa", purchasemap);
    };

    React.useEffect(() => {
        if (purchaseData?._id) {
            dispatch(viewPurchase(purchaseData?._id)).then((response) => {
                if (response.payload) {
                    const perchaseData = response.payload;
                    const totalGstAmount = perchaseData.multipledata.reduce((sum, item) => {
                        const gstAmount = (parseFloat(item.gst) || 0) * ((parseFloat(item.Qty) || 0) * (parseFloat(item.unitPrice) || 0)) / 100;
                        return sum + gstAmount;
                    }, 0);
                    setValues({
                        ...perchaseData,
                        multipledata: [...perchaseData.multipledata],
                        totalGstAmount: totalGstAmount,
                        vendor: perchaseData.vendor,
                        werehouse: perchaseData.werehouse,
                    });
                    setpurchasemap([...perchaseData.multipledata]);
                    setTotalGstAmount(totalGstAmount);
                    setFieldValue('totalGstAmount', totalGstAmount);

                    // Set accepted terms
                    if (perchaseData.terms && Array.isArray(perchaseData.terms)) {
                        const initialAcceptedTerms = perchaseData.terms.reduce((acc, termId) => {
                            acc[termId] = true;
                            return acc;
                        }, {});
                        setAcceptedTerms(initialAcceptedTerms);
                    }
                }
            }).catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }, [purchaseData?._id, dispatch]);

    const [totalGstAmount, setTotalGstAmount] = useState(0);
    const handleAddRow = () => {
        setpurchasemap([...purchasemap, {
            productName: '',
            description: '',
            HSHCode: '',
            total: 0,
            unitPrice: '',
            gst: '',
            gstAmount: 0,
            Qty: '',
        }]);
    };

    React.useEffect(() => {
        const totalTaxableAmount = purchasemap.reduce((sum, item) => {
            const unitPrice = parseFloat(item.unitPrice) || 0;
            const qty = parseFloat(item.Qty) || 0;
            return sum + (unitPrice * qty);
        }, 0);
        setFieldValue('taxableAmount', totalTaxableAmount);

        const totalGstAmount = purchasemap.reduce((sum, item) => {
            const gstAmount = parseFloat(item.gstAmount) || 0;
            return sum + gstAmount;
        }, 0);
        setFieldValue('totalGstAmount', totalGstAmount);
    }, [purchasemap, setFieldValue]);

    const handleChangeMultipleData = (index, field, value) => {
        const updatedData = [...purchasemap];
        updatedData[index][field] = value;
        setpurchasemap(updatedData);
        setFieldValue(`multipledata.${index}.${field}`, value);

        const newTotalGstAmount = updatedData.reduce((sum, item) => {
            const qty = parseFloat(item.Qty) || 0;
            const unitPrice = parseFloat(item.unitPrice) || 0;
            const gst = parseFloat(item.gst) || 0;
            const gstAmount = (gst * qty * unitPrice) / 100;
            return sum + gstAmount;
        }, 0);
        setTotalGstAmount(newTotalGstAmount);
        setFieldValue('totalGstAmount', newTotalGstAmount);
    };

    // const getMinimumUnitPrice = (productId) => {
    //     const allPrices = purchase.flatMap(p =>
    //         p.multipledata
    //             .filter(item => item.productName === productId)
    //             .map(item => parseFloat(item.unitPrice))
    //     );
    //     return allPrices.length > 0 ? Math.min(...allPrices) : '0';
    // }

    // const getAvailableQty = (selectedWarehouse, selectedProduct) => {
    //     const matchingPurchases = purchase?.filter(purchase =>
    //         purchase.werehouse === selectedWarehouse &&
    //         purchase.multipledata?.some(item => item.productName === selectedProduct)
    //     );

    //     const totalQty = matchingPurchases.reduce((sum, purchase) => {
    //         const productItem = purchase.multipledata.find(item => item.productName === selectedProduct);
    //         return sum + (productItem ? parseInt(productItem.Qty) : 0);
    //     }, 0);

    //     return totalQty;
    // };


    const getMinimumUnitPrice = (productId) => {
        const allPrices = purchase.flatMap(p =>
            p.purchaseDetails?.flatMap(pd =>
                pd.multipleQty
                    .filter(item => item.productName === productId)
                    .map(item => parseFloat(item.recieveunitPrice))
            ) || []
        ).filter(price => !isNaN(price));

        return allPrices.length > 0 ? Math.min(...allPrices) : '0';
    };

    const getAvailableQty = (selectedWarehouse, selectedProduct) => {
        const warehouseData = storeData.filter(store => store.warehouseId === selectedWarehouse);

        const productData = warehouseData?.flatMap(v => {
            return v?.multipleQty?.filter(qty => qty?.productName === selectedProduct);
        });

        const avlQty = productData?.reduce((acc, v) => acc + v.recieveQty, 0);

        return avlQty;

        // const matchingPurchases = purchase?.filter(purchase =>
        //     purchase.purchaseDetails?.some(pd =>
        //         pd.warehouseId === selectedWarehouse &&
        //         pd.multipleQty?.some(item => item.productName === selectedProduct)
        //     )
        // );

        // const totalQty = matchingPurchases.reduce((sum, purchase) => {
        //     const totalFromDetails = purchase.purchaseDetails?.reduce((detailSum, detail) => {
        //         if (detail.warehouseId === selectedWarehouse) {
        //             const productItems = detail.multipleQty.filter(item =>
        //                 item.productName === selectedProduct
        //             );
        //             return detailSum + productItems.reduce((itemSum, item) =>
        //                 itemSum + (parseInt(item.recieveQty) || 0), 0
        //             );
        //         }
        //         return detailSum;
        //     }, 0) || 0;
        //     return sum + totalFromDetails;
        // }, 0);

        // return totalQty;
    };

    const handleAddKit1 = (index) => {
        const oldKitDetails = [...values.multipledata];

        const newKit = {
            productName: '',
            description: '',
            HSHCode: '',
            Qty: '',
            unitPrice: '',
            gst: '',
        };

        oldKitDetails.splice(index + 1, 0, newKit);
        setpurchasemap(oldKitDetails);
        formik.setFieldValue('multipledata', oldKitDetails);

        formik.setTouched({
            multipledata: oldKitDetails.map((_, i) => ({
                productName: i === index + 1 ? false : touched.multipledata?.[i]?.productName,
                description: i === index + 1 ? false : touched.multipledata?.[i]?.description,
                HSHCode: i === index + 1 ? false : touched.multipledata?.[i]?.HSHCode,
                Qty: i === index + 1 ? false : touched.multipledata?.[i]?.Qty,
                unitPrice: i === index + 1 ? false : touched.multipledata?.[i]?.unitPrice,
                gst: i === index + 1 ? false : touched.multipledata?.[i]?.gst,
            })),
        });
    }

    const [openDialog, setOpenDialog] = useState(false); // To control the dialog visibility
    const [deleteIndex, setDeleteIndex] = useState(null); // To store the index of the item to be deleted

    const handleOpenDialog = (index) => {
        setDeleteIndex(index); // Set the index of the item to be deleted
        setOpenDialog(true);   // Show the confirmation dialog
    };

    const handleCloseDialog = () => {
        setOpenDialog(false); // Close the dialog without deleting
    };

    const handleDeleteConfirmed = () => {
        // Delete the item when the user confirms
        handleDeleteKit(deleteIndex);
        setOpenDialog(false); // Close the dialog after deletion
    };

    const handleDeleteKit = (index) => {
        const kitDetail = values.multipledata[index];

        if (kitDetail?._id) {
            dispatch(deletePurchaseDetails(kitDetail?._id));
        }

        const updatedKitDetails = [...values.multipledata];
        updatedKitDetails.splice(index, 1);
        setpurchasemap(updatedKitDetails);
        formik.setFieldValue('multipledata', updatedKitDetails);
    };

    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
            {purchaseData?._id ? (
                <Header
                    title="UPDATE PURCHASE"
                    subtitle="Update Your Purchase Detail"
                />
            ) : (
                <Header
                    title="ADD PURCHASE"
                    subtitle="Manage Your Purchase Detail"
                />
            )}

            <form onSubmit={handleSubmit} >
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    <Box display="grid"
                        gap="30px"
                        gridTemplateColumns={isVerySmallScreen ? "repeat(1, minmax(0, 1fr))" : "repeat(4, minmax(0, 1fr))"}
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                        }}>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="SR No :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={SrNo}
                                name="SrNo"
                                error={!!touched.SrNo && !!errors.SrNo}
                                helperText={touched.SrNo && errors.SrNo}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.PurchaseDate}
                                name="PurchaseDate"
                                error={!!touched.PurchaseDate && !!errors.PurchaseDate}
                                helperText={touched.PurchaseDate && errors.PurchaseDate}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                select
                                variant="filled"
                                label="Vendor : "
                                onBlur={handleBlur}
                                onChange={(event) => {
                                    handleChange(event);
                                    setFieldValue('vendor', event.target.value);
                                }}
                                value={values.vendor || ''}
                                name="vendor"
                                error={!!touched.vendor && !!errors.vendor}
                                helperText={touched.vendor && errors.vendor}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            >
                                {vendor?.map((v) => (
                                    <MenuItem key={v._id} value={v._id}>{v.businessName}</MenuItem>
                                ))}
                            </TextField>
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                select
                                variant="filled"
                                label="Warehouse : "
                                onBlur={handleBlur}
                                onChange={(event) => {
                                    handleChange(event);
                                    setFieldValue('werehouse', event.target.value);
                                }}
                                value={values.werehouse || ''}
                                name="werehouse"
                                error={!!touched.werehouse && !!errors.werehouse}
                                helperText={touched.werehouse && errors.werehouse}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            >
                                {Warehouse?.map((w) => (
                                    <MenuItem key={w._id} value={w._id}>{w.wareHouseName}</MenuItem>
                                ))}
                            </TextField>
                        </FormControl>
                    </Box>

                    <Box sx={{ overflowX: "auto", width: "100%" }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: "70px", fontSize: "14px" }}>Sr No</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Product Name</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Description</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>HSN Code</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Qty</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Unit Price</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>GST</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {purchasemap && purchasemap.length > 0 && purchasemap.map((person, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ width: 50 }}>{index + 1}</TableCell>
                                            <TableCell sx={{ width: '10px', }}>
                                                {/* <TextField
                                                    select
                                                    variant="filled"
                                                    // label="Product Name : "
                                                    onBlur={handleBlur}
                                                    onChange={(event) => {
                                                        const selectedProductId = event.target.value;
                                                        const selectedProduct = product.find(p => p._id === selectedProductId);
                                                        handleChange(event);
                                                        setFieldValue(`multipledata.${index}.productName`, selectedProductId);
                                                        if (selectedProduct) {
                                                            setFieldValue(`multipledata.${index}.description`, selectedProduct.Desacription);
                                                            setFieldValue(`multipledata.${index}.HSHCode`, selectedProduct.HSNcode);
                                                            setFieldValue(`multipledata.${index}.gst`, selectedProduct.taxdetails);
                                                            handleChangeMultipleData(index, 'gst', selectedProduct.taxdetails);
                                                        }
                                                    }}
                                                    value={values.multipledata?.[index]?.productName || ''}
                                                    name={`multipledata.${index}.productName`}
                                                    error={!!touched.multipledata?.[index]?.productName && !!errors.multipledata?.[index]?.productName}
                                                    helperText={touched.multipledata?.[index]?.productName && errors.multipledata?.[index]?.productName}
                                                    sx={{
                                                        width: {
                                                            xs: "200px",
                                                            sm: "220px",
                                                            md: "280px",
                                                        },
                                                        height: '40px',
                                                        "& .MuiInputBase-root": {

                                                            fontSize: "0.8rem",
                                                            height: "40px",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            padding: "0 12px",
                                                            height: "40px",
                                                            lineHeight: "40px",
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                >
                                                    {product?.map((v) => (
                                                        <MenuItem key={v._id} value={v._id}>{v.productName}</MenuItem>
                                                    ))}
                                                </TextField> */}

                                                <Autocomplete
                                                    options={product || []}
                                                    getOptionLabel={(option) => option.productName || ""}
                                                    value={
                                                        product?.find(p => p._id === values.multipledata?.[index]?.productName) || null
                                                    }
                                                    onChange={(event, newValue) => {
                                                        if (!newValue) return;

                                                        setFieldValue(`multipledata.${index}.productName`, newValue._id);
                                                        setFieldValue(`multipledata.${index}.description`, newValue.Desacription);
                                                        setFieldValue(`multipledata.${index}.HSHCode`, newValue.HSNcode);
                                                        setFieldValue(`multipledata.${index}.gst`, newValue.taxdetails);

                                                        handleChangeMultipleData(index, 'gst', newValue.taxdetails);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="filled"
                                                            name={`multipledata.${index}.productName`}
                                                            error={!!touched.multipledata?.[index]?.productName && !!errors.multipledata?.[index]?.productName}
                                                            helperText={touched.multipledata?.[index]?.productName && errors.multipledata?.[index]?.productName}
                                                            sx={{
                                                                width: {
                                                                    xs: "200px",
                                                                    sm: "220px",
                                                                    md: "280px",
                                                                },
                                                                "& .MuiInputBase-root": {
                                                                    fontSize: "0.8rem",
                                                                    height: "40px",
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ width: '10px' }}>
                                                <TextField
                                                    variant="filled"
                                                    // label="Description : "
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.multipledata?.[index]?.description || ''}
                                                    name={`multipledata.${index}.description`}
                                                    error={!!touched.multipledata?.[index]?.description && !!errors.multipledata?.[index]?.description}
                                                    helperText={touched.multipledata?.[index]?.description && errors.multipledata?.[index]?.description}
                                                    sx={{
                                                        width: {
                                                            xs: "200px",
                                                            sm: "220px",
                                                            md: "280px",
                                                        },
                                                        height: '40px',
                                                        "& .MuiInputBase-root": {

                                                            fontSize: "0.8rem",
                                                            height: "40px",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            padding: "0 12px",
                                                            height: "40px",
                                                            lineHeight: "40px",
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ width: '10px' }}>
                                                <TextField
                                                    variant="filled"
                                                    // label="HSN Code : "
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.multipledata?.[index]?.HSHCode || ''}
                                                    name={`multipledata.${index}.HSHCode`}
                                                    error={!!touched.multipledata?.[index]?.HSHCode && !!errors.multipledata?.[index]?.HSHCode}
                                                    helperText={touched.multipledata?.[index]?.HSHCode && errors.multipledata?.[index]?.HSHCode}
                                                    sx={{
                                                        width: {
                                                            xs: "200px",
                                                            sm: "220px",
                                                            md: "280px",
                                                        },
                                                        height: '40px',
                                                        "& .MuiInputBase-root": {

                                                            fontSize: "0.8rem",
                                                            height: "40px",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            padding: "0 12px",
                                                            height: "40px",
                                                            lineHeight: "40px",
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />

                                            </TableCell>
                                            <TableCell sx={{ width: '10px' }}>
                                                <TextField
                                                    variant="filled"
                                                    type="text"
                                                    // label="Qty : "
                                                    onBlur={handleBlur}
                                                    onChange={(event) => {
                                                        handleChange(event);
                                                        const qty = event.target.value || 0;
                                                        const unitPrice = values.multipledata?.[index]?.unitPrice || 0;
                                                        setFieldValue(`multipledata.${index}.total`, qty * unitPrice);
                                                        handleChangeMultipleData(index, 'Qty', qty);
                                                    }}
                                                    value={values.multipledata?.[index]?.Qty || ''}
                                                    name={`multipledata.${index}.Qty`}
                                                    error={!!touched.multipledata?.[index]?.Qty && !!errors.multipledata?.[index]?.Qty}
                                                    helperText={touched.multipledata?.[index]?.Qty && errors.multipledata?.[index]?.Qty}
                                                    sx={{
                                                        width: {
                                                            xs: "80px",
                                                            sm: "80px",
                                                            md: "130px",
                                                        },
                                                        height: '40px',
                                                        marginTop: values.multipledata?.[index]?.productName ? "22px" : "0px",
                                                        "& .MuiInputBase-root": {
                                                            fontSize: "0.8rem",
                                                            height: "40px",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            padding: "0 12px",
                                                            height: "40px",
                                                            lineHeight: "40px",
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                                {values.werehouse && values.multipledata?.[index]?.productName && (
                                                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                                        Available Qty: {getAvailableQty(values?.werehouse, values.multipledata?.[index]?.productName)}
                                                    </Typography>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ width: '10px' }}>
                                                <TextField
                                                    variant="filled"
                                                    type="text"
                                                    // label="Unit Price :"
                                                    onBlur={handleBlur}
                                                    onChange={(event) => {
                                                        handleChange(event);
                                                        const unitPrice = event.target.value || 0;
                                                        const qty = values.multipledata?.[index]?.Qty || 0;
                                                        setFieldValue(`multipledata.${index}.total`, qty * unitPrice);
                                                        handleChangeMultipleData(index, 'unitPrice', unitPrice);
                                                    }}
                                                    value={values.multipledata?.[index]?.unitPrice || ''}
                                                    name={`multipledata.${index}.unitPrice`}
                                                    error={!!touched.multipledata?.[index]?.unitPrice && !!errors.multipledata?.[index]?.unitPrice}
                                                    helperText={touched.multipledata?.[index]?.unitPrice && errors.multipledata?.[index]?.unitPrice}
                                                    sx={{
                                                        width: {
                                                            xs: "80px",
                                                            sm: "80px",
                                                            md: "130px",
                                                        },
                                                        height: '40px',
                                                        marginTop: values.multipledata?.[index]?.productName ? "22px" : "0px",
                                                        "& .MuiInputBase-root": {
                                                            fontSize: "0.8rem",
                                                            height: "40px",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            padding: "0 12px",
                                                            height: "40px",
                                                            lineHeight: "40px",
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                                {values.multipledata?.[index]?.productName && (
                                                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                                        Minimum Unit Price: {getMinimumUnitPrice(values.multipledata[index].productName)}
                                                    </Typography>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ width: '10px' }}>
                                                <TextField
                                                    variant="filled"
                                                    // label="GST : "
                                                    onBlur={handleBlur}
                                                    // onChange={handleChange}
                                                    onChange={(event) => {
                                                        handleChange(event);
                                                        const newGstValue = event.target.value;
                                                        setFieldValue(`multipledata.${index}.gst`, newGstValue);
                                                        handleChangeMultipleData(index, 'gst', newGstValue);
                                                    }}
                                                    value={values.multipledata?.[index]?.gst || ''}
                                                    name={`multipledata.${index}.gst`}
                                                    error={!!touched.multipledata?.[index]?.gst && !!errors.multipledata?.[index]?.gst}
                                                    helperText={touched.multipledata?.[index]?.gst && errors.multipledata?.[index]?.gst}
                                                    sx={{
                                                        width: {
                                                            xs: "80px",
                                                            sm: "80px",
                                                            md: "80px",
                                                        },
                                                        height: '40px',
                                                        "& .MuiInputBase-root": {
                                                            fontSize: "0.8rem",
                                                            height: "40px",
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            padding: "0 12px",
                                                            height: "40px",
                                                            lineHeight: "40px",
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <Stack spacing={2} direction="row">
                                                    <Button
                                                        variant="contained"
                                                        color="success"
                                                        onClick={() => handleAddKit1(index)}
                                                        sx={{
                                                            width: "35px",
                                                            height: "35px",
                                                            minWidth: "20px",
                                                            padding: "0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <AddIcon sx={{ fontSize: "16px" }} />
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        onClick={() => handleOpenDialog(index)} // Open the confirmation dialog
                                                        sx={{
                                                            width: "35px",
                                                            height: "35px",
                                                            minWidth: "20px",
                                                            padding: "0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <DeleteIcon sx={{ fontSize: "16px" }} />
                                                    </Button>


                                                </Stack>
                                            </TableCell>


                                        </TableRow>
                                    ))}


                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box display="flex" justifyContent="flex-end" m={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={handleAddRow}
                        >
                            Add Purchase Details
                        </Button>
                    </Box>
                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                        }}
                    >
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Taxable Amount :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.taxableAmount}
                                name="taxableAmount"
                                error={!!touched.taxableAmount && !!errors.taxableAmount}
                                helperText={touched.taxableAmount && errors.taxableAmount}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Total GST Amount :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={Math.round(totalGstAmount)}
                                name="totalGstAmount"
                                error={!!touched.totalGstAmount && !!errors.totalGstAmount}
                                helperText={touched.totalGstAmount && errors.totalGstAmount}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Amount Total :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={parseFloat(values.taxableAmount) + parseFloat(totalGstAmount)}
                                name="amountTotal"
                                error={!!touched.amountTotal && !!errors.amountTotal}
                                helperText={touched.amountTotal && errors.amountTotal}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ mt: 2, mb: 2 }}>
                        <Typography variant="h6" gutterBottom>Terms and Conditions</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {termsAndCondition?.filter(t => t.TermsType === "Purchase")?.map((t) => (
                                <Box key={t._id} sx={{ p: 1, borderRadius: 1 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={acceptedTerms[t._id] || false}
                                                onChange={() => handleTermChange(t._id)}
                                                name={`term-${t._id}`}
                                                sx={{
                                                    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                                                    '&.Mui-checked': {
                                                        color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                                                    },
                                                }}
                                            />
                                        }
                                        label={
                                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 0.5 }}>{t.name}</Typography>
                                        }
                                    />
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                    >
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            Are you sure you want to delete this item?
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>
                                Cancel
                            </Button>
                            <Button onClick={handleDeleteConfirmed} color="error">
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    handleSubmit();
                                }}
                            >
                                {purchaseData?._id ? 'Update' : 'Save'}
                            </Button>
                        </Stack>
                    </FormControl>
                </Stack>
            </form>
        </Box >
    );

}